import * as actions from './overtimeMaster/actions'
import * as mutations from './overtimeMaster/mutations'
import * as getters from './overtimeMaster/getters'

import { dataProps } from './overtimeMaster/properties'

const state = {
    list: [],
    props: JSON.parse(JSON.stringify(dataProps))
}

export default {
    state,
    getters,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/modules/overtimeMaster.js